





























































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString
} from '@/utils/tool'
import { getTubiList, getTubiOrderList } from '@/api/trade/trade'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const payTypeList = [
  {
    'id': 1,
    'name': 'PayPal'
  },
  {
    'id': 2,
    'name': '支付宝'
  },
  {
    'id': 3,
    'name': 'PaymentWall'
  }
]
const statusList = [
  {
    'id': 'new',
    'name': '新建'
  },
  {
    'id': 'success',
    'name': '成功'
  }
]
const goodsTypeList = [
  {
    'id': 1,
    'name': '1年vip'
  },
  {
    'id': 2,
    'name': '2年vip'
  },
  {
    'id': 3,
    'name': '其他'
  }
]

const payStatusList: any[] = []

@Component({
  name: 'TradeTubi'
})
export default class extends mixins(DateOption) {
  // api data
  private params: any = {
    // udid: '',
    // payType: '',
    userName: '',
    payStatus: '',
    payDateStart: '',
    payDateEnd: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20,
    refunded: ''
  }
  private formParams = {
    udid: '',
    goodsType: '',
    day: 0
  }
  // component data
  payTypeList = payTypeList
  payStatusList = payStatusList
  statusList = statusList
  goodsTypeList = goodsTypeList
  dateArrayExpire = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  tableHeight: number = 800
  rules: any = {
    udid: [{ required: true, message: '请填写UDID', trigger: 'blur' }],
    goodsType: [{ required: true, message: '请选择类别', trigger: 'change' }],
    day: [{ required: true, message: '请输入天数', trigger: 'blur' }]
  }
  // lifecycle
  async created() {
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getTubiOrderList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  handleDateChangePay(date: string[]) {
    this.params.payDateStart = date && date[0]
    this.params.payDateEnd = date && date[1]
  }
  handleDateChangeExpire(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    this.params = {
      userName: '',
      payStatus: '',
      payDateStart: '',
      payDateEnd: '',
      createDateStart: '',
      createDateEnd: '',
      page: 1,
      pageCount: 20
    }
    this.dateArrayPay = ['', '']
    this.dateArrayExpire = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formVisible = true
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  handleRefund(item: any) {
    console.log(item)
    this.$confirm('是否确认要退款?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        // let uid = ''
        // uid = item.uid
        // let res: any = await deleteAccount({ uid })
        // if (res.status.code === 0) {
        //   this['$message'].success('删除成功!')
        //   setTimeout(() => {
        //     this.getTableData()
        //   }, 1500)
        // } else {
        //   this['$message'].error('删除失败!')
        // }
      })
      .catch(() => {})
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelForm()
  }
  cancelForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }
  confirmForm() {
    (this.$refs['formParams'] as Form).validate(valid => {
      if (valid) {
        alert(1111)
      } else {
        this['$message'].warning('请填写完成后再提交!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
